import findInvoicesUseCase from "../findInvoicesUseCase"

export const SET_ALL_DATA = 'SET_ALL_DATA_INVOICES'
export const SET_ITEM = 'SET_ITEM_INVOICE'
export const DELETE_ITEM = 'DELETE_ITEM_INVOICE'

const setAllData = payload => (
    { type: SET_ALL_DATA, payload }
)

const setItem = payload => (
    { type: SET_ITEM, payload }
)

const deleteItem = payload => (
    { type: DELETE_ITEM, payload }
)


export const getInvoices = payload => {
    return async (dispatch, getState) => {

        findInvoicesUseCase(snapshot => {
            const { added, modified, removed } = getDataFromSnapshot(snapshot)

            if (getState().invoices.data.length === 0) {
                dispatch(setAllData(added))
            } else {
                Object.entries(added).forEach(([key, value]) => dispatch(setItem({ id: key, data: value })));
                Object.entries(modified).forEach(([key, value]) => dispatch(setItem({ id: key, data: value })));
                Object.entries(removed).forEach(([key, value]) => dispatch(deleteItem({ id: key })));
            }
        })
    }
}

const getDataFromSnapshot = (snapshot) => {
    let data = {
        added: {},
        modified: {},
        removed: {}
    }

    snapshot.docChanges().forEach(change => {
        const type = data[change.type]
        type[change.doc.id] = applyTransformData(change.doc.data())
    })

    return data
}

const applyTransformData = (invoices) => {
    return { ...invoices }
}